const schemas = {
  EveryMatrix: (data) => ({
    // Credentials
    email: data.credentials.email,
    username: data.credentials.username,
    alias: data.credentials.alias,
    password: data.credentials.password,
    confirm: data.credentials.password,
    passwordRepeat: data.credentials.password,
    // User data
    birthDate: data.user.birthday && data.user.birthday.toISOString().split('T')[0],
    dob: data.user.birthday && data.user.birthday.toISOString().split('T')[0],
    gender: data.user.gender && data.user.gender.slice(0, 1).toUpperCase(),
    postalCode: data.user.postalCode,
    country: data.user.country,
    region: data.user.province,
    city: data.user.city,
    address1: data.user.houseNumber + ' ' + data.user.streetName,
    phone: data.user.phone,
    mobile: data.user.mobile,
    currency: data.user.currency,
    // GDPR
    acceptNewsEmail: (data.consent.offer_email && data.consent.offer_email.consent) || false,
    acceptSMSOffer: (data.consent.offer_sms && data.consent.offer_sms.consent) || false
  }),

  aspire: (data) => {
    const birthdate = data.user.birthdate
    let mapped = {
      firstName: data.user.firstName,
      lastName: data.user.lastName,
      email: data.credentials.email,
      password: data.credentials.password,
      birthday: birthdate && birthdate.toISOString().split('T')[0],
      gender: data.user.gender,
      address: `${data.user.streetName} ${data.user.houseNumber}`,
      zipCode: data.user.postalCode,
      city: data.user.city,
      countryCode: data.user.country,
      CurrencyCode: data.user.currency && data.user.currency.toUpperCase(),
      phone: data.user.phone,
      cellPhone: data.user.phoneE164?.replace('+', '') || '',
      phonePrefix: data.user.phonePrefix,
      promoCode: data.user.promoCode,
      partnerName: data.partnerName,
      username: data.credentials.username,
      province: data.user.province,
      provinceCode: data.user.provinceCode,
      sanctions: data.sanction.flag && data.sanction.result ? data.sanction.result : [],
      consent: {
        privacy: getConsent(data.consent, 'privacy'),
        bonusPolicy: getConsent(data.consent, 'bonusPolicy'),
        age: data.appCountry === 'GB' ? getConsent(data.consent, 'terms_age') : getConsent(data.consent, 'age'),
        terms: data.appCountry === 'GB' ? getConsent(data.consent, 'terms_age') : getConsent(data.consent, 'terms'),
      }
        
    }

    if(data.variant === 'germany') {
      mapped.ocrData = data.ocrData
    }

    return mapped
  }
}

const getConsent = (consentObj, name) => ({ consent: consentObj[name] && consentObj[name].consent })

const transformData = (data, schema) => schemas[schema](data)

export default transformData



// WEBPACK FOOTER //
// ./src/utils/data-transfrom.js